import { Injectable } from "@angular/core";
import { FormGroup, FormArray, AbstractControl } from "@angular/forms";
declare var moment: any;

@Injectable({
  providedIn: "root"
})
export class HelperService {
  constructor() {}

  capitalize(s: string): string {
    return s && s[0].toUpperCase() + s.slice(1);
  }

  //This assumes that the property 'label' is present on the object
  sortObjectArray(objArray: any, moveOtherToEnd: boolean): Array<any> {
    if (objArray) {
      objArray.sort((obj1, obj2) => {
        var firstObj = obj1.label.toLowerCase();
        var secondObj = obj2.label.toLowerCase();
        return firstObj > secondObj;
      });

      if (moveOtherToEnd) {
        let otheritemindex = objArray.findIndex(this.isOtherItem);
        let manualitem = objArray.splice(otheritemindex, 1);
        objArray = objArray.concat(manualitem);
      }
    }

    return objArray;
  }

  isOtherItem(el: any) {
    return el.label.indexOf("Other") == 0;
  }

  isManualItem(el: any) {
    return el.name.indexOf("Manual") > -1;
  }

  movemanualItemToEnd(list: any) {
    if (list) {
      let manualitemindex = list.findIndex(this.isManualItem);
      if (manualitemindex != -1) {
        let manualitem = list.splice(manualitemindex, 1);
        manualitem[0].name = "I DO NOT see my program information";
        list = list.concat(manualitem);
      }
    }
    return list;
  }

  SantizeDate(date: string): string {
    if (date == "" || date == null) return "";
    return moment(date).format("MM/DD/YYYY");
  }

  MaskCreditCardNumber(number: any) {
    let _maskedcc = number;
    if (number && number.length > 4) {
      _maskedcc = number.substring(number.length - 4);
    }
    _maskedcc = "*****************" + _maskedcc;

    return _maskedcc;
  }

  objectValues(obj) {
    var res = [];
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        res.push(obj[i]);
      }
    }
    return res;
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The group to caress..hah
   */
  markFormGroupTouched(formGroup: FormGroup) {
    // (<any>Object).values(formGroup.controls).forEach(control => {
    this.objectValues(formGroup.controls).forEach(control => {
      if (control.controls) {
        // control is a FormGroup
        this.markFormGroupTouched(control);
      } else {
        // control is a FormControl
        control.markAsTouched();
      }
    });
  }

  /**
   * Marks all controls in a form group as untouched
   * @param formGroup - The group to caress..hah
   */
  markFormGroupUnTouched(formGroup: FormGroup) {
    // (<any>Object).values(formGroup.controls).forEach(control => {
    this.objectValues(formGroup.controls).forEach(control => {
      if (control.controls) {
        // control is a FormGroup
        this.markFormGroupUnTouched(control);
      } else {
        // control is a FormControl
        control.markAsUntouched();
      }
    });
  }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce(
      (acc, key) => {
        const control = form.get(key);
        const errors =
          control instanceof FormGroup || control instanceof FormArray
            ? this.getAllErrors(control)
            : control.errors;
        if (errors) {
          acc[key] = errors;
          hasError = true;
        }
        return acc;
      },
      {} as { [key: string]: any }
    );
    return hasError ? result : null;
  }

  public findInvalidControls(formGroup: FormGroup) {
    const invalid = [];
    const controls = formGroup.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  ClearValidators(formGroup: FormGroup) {
    const controls = formGroup.controls;

    for (const name in controls) {
      controls[name].clearValidators();
      controls[name].updateValueAndValidity();

      let fg = controls[name] as FormGroup;
      if (fg && fg.controls) {
        this.ClearValidators(fg);
      }
    }
  }
}
